module.exports = "/v2/pages/dashboard/dist/8bf0d48c84147cb6d32d5ed8dff09ab8.svg";